import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      image: 'https://images.pexels.com/photos/4895455/pexels-photo-4895455.jpeg',
      rating: 5,
      title: 'Expert Service and Quick Repairs',
      text: 'I brought my car in after a minor accident, and Aces Auto Body exceeded my expectations. They handled everything, from the repairs to the insurance claims, seamlessly. Highly recommended! Thanks, Aces!'
    },
    {
      name: 'Michael Chen',
      image: 'https://images.pexels.com/photos/8986130/pexels-photo-8986130.jpeg',
      rating: 5,
      title: 'Professional and Reliable',
      text: 'The team at Aces Auto Body is fantastic! They fixed my bumper quickly and at a fair price. I felt taken care of throughout the entire process. Will definitely come back for any future needs.'
    },
    {
      name: 'Jennifer Martinez',
      image: 'https://images.pexels.com/photos/15085608/pexels-photo-15085608.jpeg',
      rating: 5,
      title: 'Exceeded My Expectations!',
      text: 'I couldn\'t believe how quickly they repaired my car without compromising on quality. Exceptional service and friendly staff. Thank you, Aces! Definitely worth every penny!'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-4">
            <i className="ri-chat-quote-line text-amber-600"></i>
            <span className="text-sm text-amber-900 font-semibold">Testimonials</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our service
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 rounded-full overflow-hidden ring-4 ring-amber-100">
                  <img 
                    src={testimonials[activeIndex].image}
                    alt={`${testimonials[activeIndex].name} - satisfied customer`}
                    title={`${testimonials[activeIndex].name} testimonial`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start mb-3">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-xl"></i>
                  ))}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2 font-['Space_Grotesk']">
                  {testimonials[activeIndex].title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {testimonials[activeIndex].text}
                </p>
                <p className="text-gray-900 font-semibold">
                  {testimonials[activeIndex].name}
                </p>
              </div>
            </div>
          </div>

          <button 
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
          </button>

          <button 
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-gray-50 transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
          </button>

          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  index === activeIndex ? 'bg-amber-500 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
